import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { message } from "antd";
import { PersonForm, type PersonFormRef } from "../../OrderForms/PersonForm";
import { getCustomerDetail, updateCustomerInsured, type CustomerDTO, type InsuredDTO } from "@ifa/utils";
import CustomButton from "../../../components/CustomButton";

export function InsuredEdit() {
  const { customerId, insuredId } = useParams<{ customerId: string; insuredId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState<CustomerDTO | null>(null);
  const [insured, setInsured] = useState<InsuredDTO | null>(null);
  const personFormRef = useRef<PersonFormRef>(null);

  // 添加调试日志
  useEffect(() => {
    console.log("InsuredEdit - location.state:", location.state);
  }, [location.state]);

  useEffect(() => {
    if (!customerId || !insuredId) {
      message.error("缺少必要參數");
      navigate(-1);
      return;
    }

    setLoading(true);
    getCustomerDetail(customerId)
      .then((res) => {
        setCustomer(res);
        // Find the insured to edit
        const foundInsured = res.insureds?.find((i) => i.insuredId === Number(insuredId));
        if (foundInsured) {
          setInsured(foundInsured);
        } else {
          message.error("找不到該受保人資料");
          navigate(-1);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch customer detail:", err);
        message.error("獲取客戶資料失敗");
        navigate(-1);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [customerId, insuredId, navigate]);

  const handleSave = async () => {
    if (!customerId || !insuredId || !insured) return;

    try {
      // Validate form first
      await personFormRef.current?.validate();

      // Save
      await updateCustomerInsured(Number(customerId), Number(insuredId), insured);
      message.success("儲存成功");
      // Return to customer detail page
      navigate(`/customers/${customerId}`);
    } catch (error) {
      console.error("Failed to update insured:", error);
      // Error handled by global error handler or validation error
    }
  };

  const handleCancel = () => {
    console.log("location.state:", location.state);
    const { from, customerId, viewMode } = (location.state as any) || {};
    console.log("from:", from, "customerId:", customerId, "viewMode:", viewMode);
    // 如果是从客户列表进入,返回到客户列表并保持状态
    if (from === "customer-list" && customerId) {
      navigate("/customers", {
        state: {
          selectedCustomerId: Number(customerId),
          viewMode: viewMode || "insured", // 默认返回到受保人视图
        },
      });
    } else {
      // 默认返回到客户详情页
      navigate(`/customers/${customerId}`);
    }
  };

  // if (loading) {
  //   return <Spin size="large" tip="加載中..." fullscreen />;
  // }

  if (!insured || !customer) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "#f5f5f5",
        overflowY: "auto",
        padding: 0,
        boxSizing: "border-box",
        WebkitOverflowScrolling: "touch",
        overscrollBehavior: "none",
      }}
    >
      {/* Header */}
      <div
        style={{
          marginBottom: 24,
          display: "flex",
          alignItems: "center",
          background: "#FFFFFF",
          padding: "16px 24px",
          position: "sticky",
          top: 0,
          zIndex: 900,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
      >
        <span style={{ fontSize: 14, color: "#666", cursor: "pointer" }} onClick={handleCancel}>
          <span style={{ color: "#08C4C8" }}>客戶</span> &gt; <span style={{ color: "#08C4C8" }}>客戶詳情</span> &gt; <span style={{ color: "#333", fontWeight: 500 }}>編輯受保人</span>
        </span>
        <span style={{ marginLeft: "auto", fontSize: 20, color: "#999", cursor: "pointer" }} onClick={handleCancel}>
          ✕
        </span>
      </div>

      {/* Content */}
      <div style={{ padding: "0 40px", paddingBottom: 100 }}>
        <PersonForm ref={personFormRef} title="受保人" data={insured} onChange={(data) => setInsured(data as InsuredDTO)} readOnly={false} />
      </div>

      {/* Footer Actions */}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "16px 24px",
          background: "#fff",
          borderTop: "1px solid #eee",
          display: "flex",
          justifyContent: "space-between",
          zIndex: 100,
        }}
      >
        <CustomButton height={35} bgColor="#fff" color="#666" style={{ border: "1px solid #d9d9d9" }} onClick={handleCancel}>
          返回上一頁
        </CustomButton>
        <CustomButton height={35} onClick={handleSave}>
          確定
        </CustomButton>
      </div>
    </div>
  );
}
